export const colors = {
  white: 'rgba(255, 255, 255, 1)',
  white07: 'rgba(255, 255, 255, 0.7)',

  darkBlack: 'rgba(0, 0, 0, 1)',
  darkBlack01: 'rgba(0, 0, 0, 0.1)',
  darkBlack03: 'rgba(0, 0, 0, 0.3)',

  black: 'rgba(17, 17, 17, 1)',
  black02: 'rgba(17, 17, 17, 0.2)',
  black05: 'rgba(17, 17, 17, 0.5)',
  black07: 'rgba(17, 17, 17, 0.7)',

  lightBlack: 'rgba(32, 32, 32, 1)',

  blue: 'rgb(0, 109, 255)',
  blue07: 'rgba(0, 109, 255, 0.7)',
  brightBlue: 'rgba(25, 123, 255, 1)',
  lightBlue: 'rgba(77, 153, 255, 1)',
  lightBlue07: 'rgba(77, 153, 255, 0.7)',
  darkBlue: 'rgba(51, 28, 255, 1)',

  lightGreen: 'rgba(14, 193, 47, 1)',

  red: 'rgba(232, 32, 30, 1)',
  brightRed: 'rgba(237, 50, 71, 1)',
  brightRed07: 'rgba(237, 50, 71, 0.7)',

  brown: 'rgba(75, 22, 0, 1)',

  orange: 'rgba(255, 131, 0, 1)',
  orange07: 'rgba(255, 131, 0, 0.7)',

  yellow: 'rgba(255, 236, 0, 1)',
  yellow07: 'rgba(255, 236, 0, 0.7)',

  purple: 'rgba(141, 56, 255, 1)'
} as const;
